import React, { Dispatch, SetStateAction } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import websocketService from "../services/websocket";

import lineIcon from "../assets/svg/line.svg";
import lineIconActive from "../assets/svg/line-active.svg";
import candlestickIcon from "../assets/svg/candlestick.svg";
import candlestickIconActive from "../assets/svg/candlestick-active.svg";
import histogramIcon from "../assets/svg/histogram.svg";
import histogramIconActive from "../assets/svg/histogram-active.svg";

import "./ChartType.css";

type ChartControlProps = {
  chartType: "line" | "candlestick" | "histogram";
  setChartType: Dispatch<SetStateAction<"line" | "candlestick" | "histogram">>;
};

const ChartControl: React.FC<ChartControlProps> = ({
  chartType,
  setChartType,
}) => {
  const { selectedPair, selectedTimeframe } = useSelector(
    (state: RootState) => state.trading,
  );
  const { isConnected } = useSelector((state: RootState) => state.websocket);

  // Обработчики для кнопок типа графика
  const handleChartTypeChange = (
    newChartType: "line" | "candlestick" | "histogram",
  ) => {
    if (newChartType !== chartType) {
      setChartType(newChartType);

      // Отправляем настройки только при явном изменении типа графика пользователем
      if (selectedPair && isConnected) {
        const chartTypeMap: Record<string, string> = {
          line: "line",
          candlestick: "candles",
          histogram: "bars",
        };

        const serverChartType = chartTypeMap[newChartType] || "line";

        const ws = (websocketService as any).ws;
        if (
          ws &&
          ws.readyState === WebSocket.OPEN &&
          (websocketService as any).isAuthenticated
        ) {
          const settingsMessage = {
            t: 15, // Тип сообщения update_settings
            d: {
              pair: selectedPair,
              chart_type: serverChartType,
            },
          };

          ws.send(JSON.stringify(settingsMessage));
        }
      }
    }
  };

  return (
    <div className="controls chart-type">
      <button
        className={`button chart-type__button ${chartType === "line" ? "active" : ""}`}
        onClick={() => handleChartTypeChange("line")}
        title="Line chart"
      >
        <img
          className="chart-type__icon"
          src={chartType === "line" ? lineIconActive : lineIcon}
          alt="Line chart"
        />
      </button>

      <button
        className={`button chart-type__button ${chartType === "candlestick" ? "active" : ""}`}
        onClick={() => handleChartTypeChange("candlestick")}
        title="Candlestick chart"
      >
        <img
          className="chart-type__icon"
          src={
            chartType === "candlestick"
              ? candlestickIconActive
              : candlestickIcon
          }
          alt="Candlestick chart"
        />
      </button>

      <button
        className={`button chart-type__button ${chartType === "histogram" ? "active" : ""}`}
        onClick={() => handleChartTypeChange("histogram")}
        title="Histogram"
      >
        <img
          className="chart-type__icon"
          src={chartType === "histogram" ? histogramIconActive : histogramIcon}
          alt="Histogram"
        />
      </button>
    </div>
  );
};

export default ChartControl;
